export default "__VITE_ASSET__WbSV6t28__"